import { useContext } from 'react'

import { EmailProfileMessagesListExpandContext } from '../../Email.contexts'

export function useEmailProfileMessagesListExpandContext() {
  return useContext(EmailProfileMessagesListExpandContext)
}
